export default {"src":"https://static.spiritory.com/_next/static/media/spiritoryLogo.bc58487d.svg","height":474,"width":473,"blurWidth":0,"blurHeight":0};